import React, { useEffect, useState } from "react";
import { Seo } from "@/components/Layout";
import { PageHeader, Breadcrumbs } from "@/components/Bits";
import api from "@/lib/api";

const CAT = { "aleman-suizo": "Alemán suizo", "trabajo": "Trabajo", "vivienda": "Vivienda", "vida-cotidiana": "Vida cotidiana", "primeros-pasos": "Primeros pasos", "cultura-laboral": "Cultura laboral", "tramites": "Trámites", "dinero": "Dinero y banca", "salud": "Salud", "transporte": "Transporte" };

export default function Glossary() {
  const [terms, setTerms] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/glossary").then(({ data }) => setTerms(data)); }, []);
  const filtered = terms.filter((t) => t.term.toLowerCase().includes(q.toLowerCase()) || t.definition.toLowerCase().includes(q.toLowerCase()));
  return (
    <>
      <Seo title="Glosario de alemán para Suiza" description="Glosario enlazable de términos clave en alemán para vivir y trabajar en Suiza, incluyendo vocabulario suizo." />
      <PageHeader overline="Glosario" title="Términos clave, explicados" subtitle="Vocabulario esencial para moverte por la vida y el trabajo en la Suiza germanófona." />
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12">
        <Breadcrumbs items={[{ label: "Inicio", to: "/" }, { label: "Glosario" }]} />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar término..." data-testid="glossary-search"
          className="w-full h-11 rounded-md border border-input bg-background px-4 text-sm mb-8" />
        <div className="grid sm:grid-cols-2 gap-4">
          {filtered.map((t, i) => (
            <div key={i} id={t.term} className="rounded-lg border border-border bg-card p-5" data-testid={`glossary-${t.term}`}>
              <div className="flex items-center justify-between"><h2 className="font-display font-bold text-lg text-primary">{t.term}</h2><span className="text-xs text-muted-foreground">{CAT[t.category] || t.category}</span></div>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{t.definition}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
